"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceEmptyPTags = exports.renderScenario = exports.renderQuestionComment = exports.renderQuestion = exports.renderHint = exports.removeHtmlTags = exports.getSortedOptions = exports.decodeText = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.sort.js");
var _react = _interopRequireDefault(require("react"));
var _html = require("@citrus/html");
var _reactInsetBanner = _interopRequireDefault(require("@pcty/react-inset-banner"));
var _isNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNullOrEmpty"));
var he = _interopRequireWildcard(require("he"));
var _inputTextarea = require("@citrus/input-textarea");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var decodeText = exports.decodeText = function decodeText(text) {
  var fixedText = text;
  if (text) {
    fixedText = he.decode(text);
    fixedText = fixedText.replace(/“|”/g, '"');
    fixedText = fixedText.replace(/‘|’/g, "'");
  }
  return fixedText;
};
var removeHtmlTags = exports.removeHtmlTags = function removeHtmlTags(question) {
  return question.replace(/<\/?[^>]+>/gi, '');
};
var replaceEmptyPTags = exports.replaceEmptyPTags = function replaceEmptyPTags(content) {
  return content ? content.replace(/<p><\/p>/gi, '<br/>') : content;
};
var renderQuestion = exports.renderQuestion = function renderQuestion(id, number, question, required, readOnly) {
  var spliceString = function spliceString(sourceString, startIndex, insertString) {
    return sourceString.substring(0, startIndex) + insertString + sourceString.substring(startIndex);
  };
  if ((0, _isNullOrEmpty.default)(question)) return null;
  var requiredAsterisk = readOnly ? '*' : '<span class="pcty-answer-required">*</span>';
  var prefix = "".concat(required ? requiredAsterisk : '', " ").concat(number, ". ");
  var questionText = question.indexOf('<p>') === 0 ? spliceString(question, 3, prefix) : prefix + question;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12 pcty-padding-top pcty-padding-bottom pcty-survey-question-label-container",
    id: "question-text-".concat(id)
  }, /*#__PURE__*/_react.default.createElement(_html.Html, {
    className: "pcty-survey-question-label",
    content: replaceEmptyPTags(questionText),
    id: id + '-question-content',
    htmlWrapperType: "span",
    type: "html"
  })));
};
var renderScenario = exports.renderScenario = function renderScenario(id, scenario) {
  if ((0, _isNullOrEmpty.default)(scenario)) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-question"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_html.Html, {
    content: scenario,
    id: id + '-scenario',
    type: "html"
  })));
};
var renderHint = exports.renderHint = function renderHint(id, hint) {
  if ((0, _isNullOrEmpty.default)(hint)) return null;
  return /*#__PURE__*/_react.default.createElement(_reactInsetBanner.default, {
    id: 'information-inset-banner-hint-' + id,
    type: "information"
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, hint));
};
var renderQuestionComment = exports.renderQuestionComment = function renderQuestionComment(id, readOnly, allowComments, commentsPlaceholder, comment, onComment, disabled) {
  return allowComments && /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-left pcty-padding-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
    id: "".concat(id, "-comment-textarea"),
    maxLength: 2000,
    readOnly: readOnly,
    onChange: function onChange(e) {
      return onComment(id, e.value);
    },
    label: "Comments",
    placeholder: commentsPlaceholder,
    value: comment,
    disabled: disabled
  })));
};
var getSortedOptions = exports.getSortedOptions = function getSortedOptions(_ref) {
  var array = _ref.array,
    sortOrder = _ref.sortOrder;
  var retArr = (0, _toConsumableArray2.default)(array);
  var shuffleFunc = function shuffleFunc() {
    for (var i = retArr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref2 = [retArr[j], retArr[i]];
      retArr[i] = _ref2[0];
      retArr[j] = _ref2[1];
    }
    return retArr;
  };
  var sortFunc = function sortFunc(a, b) {
    var valuea = a.value.toUpperCase().replace(/\s/gi, '');
    var valueb = b.value.toUpperCase().replace(/\s/gi, '');
    var comparison = 0;
    if (valuea > valueb) {
      comparison = 1;
    } else if (valuea < valueb) {
      comparison = -1;
    }
    return comparison;
  };
  switch (sortOrder) {
    case 'ascending':
      return retArr.sort(function (a, b) {
        return sortFunc(a, b);
      });
    case 'descending':
      return retArr.sort(function (a, b) {
        return sortFunc(a, b);
      }).reverse();
    case 'random':
      return shuffleFunc();
    default:
      return retArr;
  }
};